/**
 * Store admin — full-tab live preview of one saved appearance (spec 50).
 *
 * Opened in a new tab from the editor toolbar or the appearance library.
 * `?version=<uuid>` pins the preview to one saved version — the editor sets it
 * when a version from the history picker is on the canvas, so this tab shows
 * what the merchant is actually looking at rather than the current version.
 */
import { createFileRoute } from "@tanstack/react-router";
import { AppearancePreviewPage } from "../../../../../../../features/store/storefront/appearance-preview-page.tsx";

export const Route = createFileRoute(
  "/(workspace)/store/admin/storefront/$appearanceId/preview/",
)({
  validateSearch: (search: Record<string, unknown>) => ({
    version: typeof search["version"] === "string" ? search["version"] : undefined,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { appearanceId } = Route.useParams();
  const { version } = Route.useSearch();
  return (
    <AppearancePreviewPage
      appearanceId={appearanceId}
      {...(version ? { versionId: version } : {})}
    />
  );
}
